export enum EUserRoles {
  ADMIN = 'admin',
  USER = 'user',
}

export type TUser = {
  id: string;
  createdAt: string;
  email: string;
  updatedAt: string;
  role: EUserRoles;
};
// Register
export type TUsersRegisterBE = { message: string; data: TUser };
export type TUsersRegisterBody = { email: string; password: string };

// Login
export type TUsersLoginBE = { accessToken: string };
export type TUsersLoginBody = { email: string; password: string };

// Refresh
export type TUsersRefreshBE = { accessToken: string };

// Google Auth
export type TUsersGoogleAuthBE = { accessToken: string };
export type TUsersGoogleAuthBody = { idToken: string };

// Get Me
export type TUsersGetMeBE = TUser;

// Verify Email

export type TUsersVerifyEmailBE = { message: string };
export type TUsersVerifyEmailBody = { token: string };

// Request Reset Password

export type TUsersRequestResetPasswordBE = { message: string };
export type TUsersRequestResetPasswordBody = { email: string };

// Reset Password

export type TUsersResetPasswordBE = { message: string };
export type TUsersResetPasswordBody = { token: string; password: string };
